import actions from './actions';

const initState = {
    rateDeleted: false,
    ratings   : {
        data: []
    },
    loading : false,
};

export default function fetchRatingsReducer(state = initState, action) {
    switch (action.type) {
        case actions.FETCH_RATINGS_REQUESTED:
            return {
                ...state,
                ratings   : {
                    data: []
                },
                loading : true
            };
        case actions.FETCH_RATINGS_SUCCEEDED:
            return {
                ...state,
                ratings    : action.ratings,
                loading     : false
            };
        case actions.FETCH_RATINGS_FAILED:
            return {
                ...state,
                loading : false
            };

        case actions.DELETE_RATE_REQUESTED:
            return {
                ...state,
                rateDeleted: false,
                loading : true
            };
        case actions.DELETE_RATE_SUCCEEDED:
            return {
                ...state,
                rateDeleted : true,
                loading     : false
            };
        case actions.DELETE_RATE_FAILED:
            return {
                ...state,
                loading : false
            };
        default:
            return state;
    }
}
